import React from 'react';
import { Crown, Wallet } from 'lucide-react';
import { truncateAddress } from '../../utils/format';
import { formatDistanceToNow } from '../../utils/date';
import type { LeaderboardEntry as LeaderboardEntryType } from '../../types/leaderboard';

interface LeaderboardEntryProps {
  entry: LeaderboardEntryType;
}

export function LeaderboardEntry({ entry }: LeaderboardEntryProps) {
  return (
    <div className="grid grid-cols-4 gap-4 p-4 items-center hover:bg-gray-750">
      <div className="flex items-center gap-2">
        <span className="text-amber-500 font-mono w-8">#{entry.rank}</span>
        <div className="flex items-center gap-1">
          {entry.rank === 1 && <Crown className="w-4 h-4 text-yellow-400" />}
          <span className="text-white">{entry.username}</span>
        </div>
      </div>
      
      <div className="flex items-center gap-1 text-gray-400">
        <Wallet className="w-3 h-3" />
        <span className="font-mono text-sm">{truncateAddress(entry.walletAddress)}</span>
      </div>
      
      <div className="font-mono text-yellow-400">
        {entry.points.toLocaleString()}
      </div>
      
      <div className="text-sm text-gray-400">
        {formatDistanceToNow(new Date(entry.lastUpdated))}
      </div>
    </div>
  );
}